import { Controller } from "@hotwired/stimulus"

// The import intro's paste-or-upload form. "Upload a .csv File Instead"
// opens the hidden file input and a chosen file submits the form straight
// away (the server parses it); "Preview import" waits until there is
// something pasted. Without JavaScript the form still submits as is.
export default class extends Controller {
  static targets = ["text", "file", "submit"]

  connect() {
    this.sync()
  }

  sync() {
    const hasText = this.textTarget.value.trim() !== ""
    const hasFile = this.fileTarget.files && this.fileTarget.files.length > 0
    this.submitTarget.disabled = !(hasText || hasFile)
  }

  pick() {
    this.fileTarget.click()
  }

  changed() {
    if (this.fileTarget.files && this.fileTarget.files.length > 0) {
      this.element.requestSubmit()
    }
  }
}
